module.exports = "/_next/static/images/8c902af93be7c34cae12aea9ed892438-blog3a-lg.jpg";